namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceDtRow {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        SalesVatType?: string;
        DocType?: number;
        PluCode?: string;
        ItemDescription?: string;
        SerialNo?: string;
        Qty?: number;
        SellUnit?: string;
        UnitPrice?: number;
        ExPrice?: number;
        ItemDiscount?: number;
        ItemCharge?: number;
        ItemExVat?: number;
        ItemNetExprice?: number;
        AllocatedBillDiscount?: number;
        AllocatedBillDiscountVat?: number;
        ItemNetSales?: number;
        ItemNetSales2?: number;
        VatType?: string;
        VatRate?: number;
        ItemVatAmt?: number;
        ItemVatAmt2?: number;
        ItemPromoFg?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsTaxInvoiceDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.PsTaxInvoiceDt';
        export const lookupKey = 'PsTaxInvoiceDtRow';

        export function getLookup(): Q.Lookup<PsTaxInvoiceDtRow> {
            return Q.getLookup<PsTaxInvoiceDtRow>('PsTaxInvoiceDtRow');
        }
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';
        export const readPermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:View';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            SalesVatType = "SalesVatType",
            DocType = "DocType",
            PluCode = "PluCode",
            ItemDescription = "ItemDescription",
            SerialNo = "SerialNo",
            Qty = "Qty",
            SellUnit = "SellUnit",
            UnitPrice = "UnitPrice",
            ExPrice = "ExPrice",
            ItemDiscount = "ItemDiscount",
            ItemCharge = "ItemCharge",
            ItemExVat = "ItemExVat",
            ItemNetExprice = "ItemNetExprice",
            AllocatedBillDiscount = "AllocatedBillDiscount",
            AllocatedBillDiscountVat = "AllocatedBillDiscountVat",
            ItemNetSales = "ItemNetSales",
            ItemNetSales2 = "ItemNetSales2",
            VatType = "VatType",
            VatRate = "VatRate",
            ItemVatAmt = "ItemVatAmt",
            ItemVatAmt2 = "ItemVatAmt2",
            ItemPromoFg = "ItemPromoFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
